import React, { Component } from "react";
import $ from "jquery";
import axios from "axios";
import { Link } from "react-router-dom";
import Files from "react-files";

import PropTypes from "prop-types";
import "../styles/components/ContactForm.css";
import "../styles/components/ContactForm.css";
import Button from "./global/Button";

export default class ContactForm extends Component {
  constructor(props) {
    super(props);

    this.textInput = React.createRef();

    this.state = {
      firstName: "",
      lastName: "",
      phone: "",
      email: "",
      subject: "",
      message: "",
      checkbox: false,
      files: [],
      messageType: "",
      messagesValues: []
    };
  }

  inputControll() {
    $(".field-input").focus(function() {
      $(this)
        .parent()
        .addClass("is-focused has-label");
    });
    $(".field-input").blur(function() {
      const $parent = $(this).parent();
      if ($(this).val() === "") {
        $parent.removeClass("has-label");
      }
      $parent.removeClass("is-focused");
    });
  }

  sendEmail(e) {
    e.preventDefault();

    if (
      this.state.firstName === "" ||
      this.state.lastName === "" ||
      this.state.email === "" ||
      this.state.message === ""
    ) {
      this.setState({
        messageType: "info",
        messagesValues: ["! Musisz uzupełnić wszystkie wymagane pola."]
      });
    } else if (this.state.email !== "" && !this.state.email.includes("@")) {
      this.setState({
        messageType: "info",
        messagesValues: ["! Upewnij się czy wpisany adres email jest poprawny."]
      });
    } else if (!this.state.checkbox) {
      this.setState({
        messageType: "info",
        messagesValues: [
          "! By przesłać formularz konieczne jest zaakceptowanie zgody."
        ]
      });
    } else {
      const formData = new FormData();
      Object.keys(this.state.files).forEach(key => {
        const file = this.state.files[key];
        formData.append(
          key,
          new Blob([file], { type: file.type }),
          file.name || "file"
        );
      });

      axios({
        method: "post",
        url: `https://v1rage.com/contact/index.php`,
        headers: {
          "Access-Control-Allow-Origin": "https://v1rage.com",
          "content-type": "application/json"
        },
        data: {
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          phone: this.state.phone,
          email: this.state.email,
          subject: this.state.subject,
          message: this.state.message,
          files: formData
        }
      })
        .then(result => {
          this.setState(
            {
              firstName: "",
              lastName: "",
              phone: "",
              email: "",
              subject: "",
              message: "",
              files: [],
              messageType: "success",
              messagesValues: ["Formularz został poprawnie wysłany."]
            },
            () => {
              setTimeout(() => {
                this.setState({
                  messageType: "",
                  messagesValues: []
                });
              }, 10000);
            }
          );
        })
        .catch(error => {
          console.error(error);
          this.setState(
            {
              messageType: "error",
              messagesValues: [
                "Przepraszamy! Wystąpił błąd podczas wysyłania formularza. Prosimy spróbować ponownie później."
              ]
            },
            () => {
              setTimeout(() => {
                this.setState({
                  messageType: "",
                  messagesValues: []
                });
              }, 10000);
            }
          );
        });
    }
  }

  onFilesChange = files => {
    this.setState({
      messageType: "",
      messagesValues: [],
      files
    });
  };

  onFilesError = (error, file) => {
    this.setState({
      messageType: "error",
      messagesValues: [
        "error file: " + file.id + " - " + error.code + ": " + error.message
      ]
    });
  };

  filesRemoveOne = file => {
    this.refs.files.removeFile(file);
  };

  handleChange(e) {
    e.preventDefault();

    this.setState({ [e.target.id]: e.target.value, messagesValues: [] });
  }

  componentDidMount() {
    this.inputControll();
  }

  render() {
    const { wrapperClasses } = this.props;
    return (
      <div className={wrapperClasses}>
        <form className="row" action="#" ref={this.textInput}>
          <div className="col-12 col-sm-6">
            <div className="field required">
              <label htmlFor="firstName" className="field-label">
                Imię
              </label>
              <input
                type="text"
                id="firstName"
                className="field-input"
                onChange={e => this.handleChange(e)}
                value={this.state.firstName}
              />
            </div>
          </div>
          <div className="col-12 col-sm-6">
            <div className="field required">
              <label htmlFor="lastName" className="field-label">
                Nazwisko
              </label>
              <input
                type="text"
                id="lastName"
                className="field-input"
                onChange={e => this.handleChange(e)}
                value={this.state.lastName}
              />
            </div>
          </div>
          <div className="col-12 col-sm-6">
            <div className="field">
              <label htmlFor="phone" className="field-label">
                Telefon
              </label>
              <input
                type="text"
                id="phone"
                className="field-input"
                onChange={e => this.handleChange(e)}
                value={this.state.phone}
              />
            </div>
          </div>
          <div className="col-12 col-sm-6">
            <div className="field required">
              <label htmlFor="email" className="field-label">
                Adres Email
              </label>
              <input
                type="text"
                id="email"
                className="field-input"
                onChange={e => this.handleChange(e)}
                value={this.state.email}
              />
            </div>
          </div>
          <div className="col-12">
            <div className="field">
              <label htmlFor="subject" className="field-label">
                Temat
              </label>
              <input
                type="text"
                id="subject"
                className="field-input"
                onChange={e => this.handleChange(e)}
                value={this.state.subject}
              />
            </div>
          </div>
          <div className="col-12">
            <div className="field required">
              <label htmlFor="message" className="field-label">
                Treść Wiadomości
              </label>
              <textarea
                type="text"
                id="message"
                className="field-input"
                onChange={e => this.handleChange(e)}
                value={this.state.message}
              />
            </div>
          </div>
          {this.state.files.length > 0 ? (
            <div className="col-12 files-list">
              <p>Załączniki: </p>
              {this.state.files.map(file => (
                <span className="files-list-item" key={file.id}>
                  <div className="files-list-item-content">
                    <div className="files-list-item-content-item">
                      <span
                        id={file.id}
                        className="files-list-item-remove"
                        onClick={this.filesRemoveOne.bind(this, file)} // eslint-disable-line
                      >
                        X
                      </span>
                      {file.name} ({file.sizeReadable})
                    </div>
                  </div>
                </span>
              ))}
            </div>
          ) : null}
        </form>
        <div className="form-button">
          <Button
            id={this.props.pageType}
            classes={`btn-general btn-general--noBackground no-icon`}
            text={`Wyślij`}
            onClick={e => this.sendEmail(e)}
          />
          <Files
            ref="files"
            className="btn-link btn-upload btn-link--primary"
            onChange={this.onFilesChange}
            onError={this.onFilesError}
            accepts={["image/*", "video/mp4", "audio/*", ".pdf"]}
            multiple
            maxFiles={10}
            maxFileSize={10000000}
            minFileSize={0}
            clickable
          >
            Załącz plik
          </Files>
        </div>
        {this.state.messagesValues.length > 0 && (
          <div
            className={`col-12 error-message message-${this.state.messageType}`}
          >
            {this.state.messagesValues.map((error, idx) => {
              return <span key={error + idx.toString()}>{error}</span>;
            })}
          </div>
        )}
        <div className="form-desc">
          <input
            type="checkbox"
            id="checkbox-stream-3"
            value="checkbox"
            onChange={e => {
              this.setState({
                checkbox: e.target.checked,
                messagesValues: []
              });
            }}
          />
          <label htmlFor="checkbox-stream-3" className="checkbox">
            Wyrażam zgodę na przetwarzanie danych osobowych zgodnie z ustawą o
            ochronie danych osobowych w związku z wysłanie zapytania przez
            formularz kontaktowy. Podanie danych jest dobrowolne, ale niezbędne
            do przetworzenia zapytania. Zostałem poinformowany, że przysługuje
            mi prawo dostępu do swoich danych osobowych, możliwości ich
            poprawiania, żądania zaprzestania ich przetwarzania.
          </label>
          <p>
            Administratorem danych osobowych jest V1RAGE Sp. z o.o.  z siedzibą
            w Krakowie. Dane wpisane w formularzu kontaktowym będą przetwarzane
            w celu udzielenia odpowiedzi na przesłane zapytanie zgodnie z
            regulaminem
            <Link target="_blank" to="/regulamin">
              https://v1rage.com/regulamin
            </Link>
          </p>
        </div>
      </div>
    );
  }
}

ContactForm.propTypes = {
  wrapperClasses: PropTypes.string
};

ContactForm.defaultProps = {
  wrapperClasses: ""
};
